import classes from "./FastChart.module.css";
import { makeStyles } from "@material-ui/core/styles";
import { useEffect, useRef, useState } from "react";
import { useAllContexts } from "../../../hooks/useAllContexts";
import {
  getAllBinStats,
  getSensorGraphOptions,
  getSingleBinStats,
} from "../../../services/services";
import { Button, InputLabel, MenuItem, Select } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
// import { useStore } from "../../../hooks/store";
import ChartLine from "../ChartLine";
import MemorandumValues from "../MemorandumValues/MemorandumValues";
// import {
//   allBinsCharts,
//   specificBinChart,
//   enviCharts,
// } from "../../../../SMARTCITY/hardCodeData/DATA";
import EnviDatePicker from "./EnviDatePicker";
import LineChart from "./LineChart";

const useStyles = makeStyles((theme) => ({
  selectEmpty: {
    "& .Mui-disabled": {
      color: "rgba(255, 255, 255, 0.4)",
    },
    marginTop: theme.spacing(2),
    width: "100%",
    color: "black",
    textAlign: "left",
    paddingLeft: "5px",
    "&:before": {
      borderBottom: "2px solid rgb(92, 99, 106)",
    },
    "&:hover:before": {
      borderBottom: "4px solid rgb(92, 99, 106) !important",
    },
    "&:after": {
      borderBottom: "4px solid rgb(92, 99, 106)",
    },
    "& .MuiSelect-icon": {
      color: "black",
    },
  },
}));

const initStatisticData = {
  description: "Πληρότητα",
  name: "Κάδοι",
  unit: "%",
  details: [],
};

const FastChart = ({ typeId }) => {
  // const state = useStore()[0];
  const classes_select = useStyles();
  const { environment } = useAllContexts();
  const categoryName = useRef({ single: "", plural: "" });

  const [activeOption, setActiveOption] = useState(0);
  const [selectList, setSelectList] = useState([]);

  const [binsList, setBinsList] = useState([]);
  const [percBins, setPercBins] = useState([]); // 90%, 75%, 55%, 15%, 0%

  const [statisticData, setStatisticData] = useState(initStatisticData);

  // const controller = new AbortController();
  // const { signal } = controller;

  const [enviSensorVars, setEnviSensorsVars] = useState([]);
  const [availableEnviSensorVars, setAvailableEnviSensorsVars] = useState([]);
  const [enviSensors, setEnviSensors] = useState(null);
  const [selectedEnviSensor, setSelectedEnviSensor] = useState(0);
  const [enviSensorData, setEnviSensorData] = useState(null);
  const [startingDate, setStartingDate] = useState(null);
  const [endingDate, setEndingDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // useEffect(() => {
  //   return () => {
  //     controller.abort();
  //   };
  // }, []);

  useEffect(() => {
    const fetchEnviSensors = async () => {
      const sensorsData = await getSensorGraphOptions().then(
        (response) => response
      );
      setEnviSensorsVars(sensorsData.sensor_vars);
      setEnviSensors(sensorsData.sensors);
    };

    if (typeId === "1") fetchEnviSensors();
  }, []);

  useEffect(() => {
    if (typeId === "1") {
      categoryName.current = {
        single: "Περιβαλλοντικός",
        plural: "Περιβαλλοντικοί",
      };

      const tempStartingDate = new Date();
      tempStartingDate.setDate(tempStartingDate.getDate() - 7);
      setStartingDate(tempStartingDate);
      setEndingDate(new Date());
    } else if (typeId === "9")
      categoryName.current = { single: "Κάδος", plural: "Κάδοι" };
  }, [typeId]);

  useEffect(() => {
    if (typeId === "9") {
      setActiveOption(0);
      setSelectList(binsList);
    } else setSelectList([]);
  }, [binsList, typeId]);

  // useEffect(() => {
  //   if (state?.sensors.length > 0) {
  //     const tempSensors = state?.sensors?.filter(
  //       (item) => item.typeId === typeId
  //     );

  //     if (typeId === "9") {
  //       setBinsList(tempSensors);
  //     }
  //   }
  // }, [state]);

  const getSensorData = async (sensorId, varId, date) => {
    setIsLoading(true);
    const dateStart = `${date[0].getFullYear()}-${
      date[0].getMonth() + 1 < 10
        ? `0${date[0].getMonth() + 1}`
        : date[0].getMonth() + 1
    }-${date[0].getDate() < 10 ? `0${date[0].getDate()}` : date[0].getDate()}`;

    const dateEnd = `${date[1].getFullYear()}-${
      date[1].getMonth() + 1
    }-${date[1].getDate()}`;
    const data = await fetch(
      `https://kalamaria.smartiscity.gr/api/api.php?func=get_sensor_graphs&sensor_id=${sensorId}&sensor_var=${varId}&start_date=${dateStart}&end_date=${dateEnd}`
    )
      .then((response) => {
        if (response) {
          setIsLoading(false);
          const rsp = response.json();
          console.log("TEST: response:", rsp);
          return rsp;
        }
      })
      .catch((error) => {
        console.log("TEST: ERROR:", error);
        return {};
      });

    setEnviSensorData(data[0] ?? {});
  };

  useEffect(() => {
    if (typeId === "9") {
      if (activeOption === 0)
        getStatisticsAllBins().catch((error) => console.error(error));
      else getStatisticsFromABin().catch((error) => console.error(error));
    }
  }, [activeOption]);

  useEffect(() => {
    if (selectedEnviSensor !== "0") {
      const enviItem =
        environment.environmentalData?.find(
          (envi) => envi.mysensor_id === selectedEnviSensor
        )?.details ?? [];
      console.log("selectedEnviSensor:", selectedEnviSensor);
      console.log("enviItem:", enviItem);
      setAvailableEnviSensorsVars(enviItem);
    }
  }, [selectedEnviSensor]);

  // useEffect(() => {
  //   if (binsList.length > 0) {
  //     let avg = 0;
  //     let min = 100;
  //     let max = 0;
  //     const fullBins = [];
  //     const bins = [];
  //     const halfBins = [];
  //     const lowBins = [];
  //     const emptyBins = [];
  //     binsList.map((bin) => {
  //       bin.metrics.map((item) => {
  //         if (item.content === "Ποσοστό πληρότητας κάδου") {
  //           const value = parseFloat(item.value.replace("%", ""));

  //           if (value > 90) fullBins.push(bin);
  //           else if (value > 75) bins.push(bin);
  //           else if (value > 55) halfBins.push(bin);
  //           else if (value > 15) lowBins.push(bin);
  //           else emptyBins.push(bin);

  //           avg += value;
  //           if (value > max) max = value;
  //           if (value < min) min = value;
  //         }
  //       });
  //     });

  //     const garbages = [];
  //     garbages.push(fullBins, bins, halfBins, lowBins, emptyBins);
  //     setPercBins(garbages);
  //   }
  // }, [binsList]);

  const handleChange = (event) => {
    setActiveOption(event.target.value);
  };

  const getStatisticsAllBins = async () => {
    const data = await getAllBinStats().then((response) => response);
    if (data === null) return;

    let avg = 0;
    let min = 100;
    let max = 0;

    for (let i = 0; i < data.length; i++) {
      if (Number(data[i].value) > max) max = Number(data[i].value);
      if (Number(data[i].value) < min) min = Number(data[i].value);
      avg += Number(data[i].value);
    }

    setStatisticData({
      ...initStatisticData,
      min,
      max,
      avg: avg / data.length,
      details: data.map((item) => ({
        date_insert: `id/${item.id}`,
        datetime: `id/${item.id}`,
        val: item.value,
      })),
    });
  };

  const getStatisticsFromABin = async () => {
    const data = await getSingleBinStats(activeOption).then(
      (response) => response
    );
    if (data === null) return;

    let avg = 0;
    let min = 100;
    let max = 0;

    for (let i = 0; i < data.length; i++) {
      if (Number(data[i].value) > max) max = Number(data[i].value);
      if (Number(data[i].value) < min) min = Number(data[i].value);
      avg += Number(data[i].value);
    }

    setStatisticData({
      ...initStatisticData,
      min,
      max,
      avg: avg / data.length,
      details: data.map((item) => ({
        date_insert: item.labelDate,
        datetime: item.labelDate.split("-").reverse().join("/"),
        val: item.value,
      })),
    });
  };

  return (
    <div className={classes.fastChart} style={{ padding: "20px" }}>
      <InputLabel
        style={{
          margin: "0 auto",
          textAlign: "left",
          color: "black",
        }}
      >
        {categoryName.current.single}
      </InputLabel>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
        }}
      >
        {typeId === "1" && (
          <Select
            className={classes_select.selectEmpty}
            value={selectedEnviSensor}
            onChange={(event) => setSelectedEnviSensor(event.target.value)}
            placeholder="Επέλεξε περιοχή"
          >
            <MenuItem key={`sensor_zero`} value={0}>
              Όλοι οι αισθητήρες
            </MenuItem>

            {environment.environmentalData?.map((sensor) => {
              return (
                <MenuItem
                  key={`sensor_${sensor.mysensor_id}`}
                  value={sensor.mysensor_id}
                >
                  {sensor.mysensor_name}
                </MenuItem>
              );
            })}
          </Select>
        )}

        <Select
          className={classes_select.selectEmpty}
          value={activeOption}
          onChange={handleChange}
        >
          <MenuItem
            value={0}
          >{`Όλοι οι ${categoryName.current.plural}`}</MenuItem>
          {/* {typeId === "9" &&
            selectList?.map((item, index) => (
              <MenuItem key={index} value={item.id}>
                {item.title}
              </MenuItem>
            ))} */}
          {typeId === "1" &&
            availableEnviSensorVars?.map((item, id) => (
              <MenuItem
                key={`sensorvarID_${item.sensorvar_id}`}
                value={item.sensorvar_id}
              >
                {item.sensorvar_description}
              </MenuItem>
            ))}
        </Select>
      </div>
      {typeId === "1" && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
            marginTop: "20px",
          }}
        >
          <p>Περίοδος:</p>
          <EnviDatePicker
            date={{ get: startingDate, set: setStartingDate }}
            name="Αρχή"
          />
          <EnviDatePicker
            date={{ get: endingDate, set: setEndingDate }}
            name="Τέλος"
          />
          <Button
            color="primary"
            disabled={selectedEnviSensor === 0 || activeOption === 0}
            size="large"
            variant="contained"
            onClick={() => {
              if (selectedEnviSensor !== 0 && activeOption !== 0) {
                getSensorData(selectedEnviSensor, activeOption, [
                  startingDate,
                  endingDate,
                ]);
              }
            }}
          >
            Επιλογή
          </Button>
        </div>
      )}

      {isLoading && (
        <div
          style={{
            width: "100%",
            height: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p>Φόρτωση Δεδομένων...</p>
        </div>
      )}

      {typeId === "1" && !isLoading && (
        <div style={{ padding: "20px 0" }}>
          {enviSensorData && (
            <LineChart
              labels={enviSensorData?.labels}
              datas={enviSensorData?.values}
              name={enviSensorData?.sensorvar_description}
              area={enviSensorData?.mysensor_name}
              valueSign={enviSensorData?.sensorvar_unit}
            />
          )}
        </div>
      )}

      {typeId === "9" && (
        <div style={{ padding: "0 10px" }}>
          {statisticData && <ChartLine data={statisticData} type={3} />}
        </div>
      )}

      {typeId === "9" && (
        <>
          <MemorandumValues
            values={percBins}
            title={categoryName.current.plural}
            labels={["90%", "75%", "55%", "15%", "0%"]}
          />
        </>
      )}
    </div>
  );
};

export default FastChart;
